import * as types from "../../mutation-types";

const mutations = {
  [types.SET_DXGRID_SETTINGS]: (state, payload) => {
    state.grid_settings = payload;
  },
  [types.UPDATE_DXGRID_SETTINGS]: (state, payload) => {
    state.grid_settings.splice(
      state.grid_settings.indexOf(
        state.grid_settings.find((c) => c.uuid === payload.uuid)
      ),
      1,
      payload
    );
  },
};

export default mutations;
